import { appConstant } from '@constants';
import Actions from './action';

export const initState = {
	crmLoading: true,
	isApproving: false,
	isRejecting: false,
	response: null,
	userDetails: {
		email: '',
		accessLevel: '',
	},
};

const crmReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.AUTHORIZE_SUCCESS: {
			return {
				...state,
				crmLoading: false,
				userDetails: action.userDetails,
			};
		}
		case Actions.types.AUTHORIZE_FAILED: {
			return {
				...state,
				crmLoading: false,
			};
		}
		case Actions.types.APPROVE_STARTED: {
			return {
				...state,
				isApproving: !state.isApproving,
			};
		}
		case Actions.types.APPROVE_SUCCESS: {
			return {
				...state,
				isApproving: false,
				response: appConstant.success,
			};
		}
		case Actions.types.APPROVE_FAILED: {
			return {
				...state,
				isApproving: false,
				response: appConstant.failed,
			};
		}
		case Actions.types.REJECT_STARTED: {
			return {
				...state,
				isRejecting: !state.isRejecting,
			};
		}
		case Actions.types.REJECT_SUCCESS: {
			return {
				...state,
				isRejecting: false,
			};
		}
		case Actions.types.REJECT_FAILED: {
			return {
				...state,
				isRejecting: false,
			};
		}
		default:
			return state;
	}
};

export default crmReducer;
